



























































import {Vue, Component, Prop} from 'vue-property-decorator';
import { getCurrency } from '@/utils/commonUtils';
// import { postPredict } from 'supporter';
@Component
export default class ComponentDiscountShippingFee extends Vue { //B

  @Prop({required: true})
  private objJson!: string;

  @Prop({required: true})
  private postPredict!: {};

  @Prop({default: ''})
  private pageName!: string ;

  @Prop({default: false})
  private reSetData!: boolean ;
  
  private getCurrency = getCurrency;
  
  private get discountAmt(): number {
    // @NOTE postPredict 타입을 현재 시점에서 유추할 수 없어 any 로 처리함
    const { order } = (this.postPredict as any).amounts.refund;
    return order.standardAmt - order.immediateDiscountAmt
  }
  
  private get totalProductAmt(): number {
    // @NOTE postPredict 타입을 현재 시점에서 유추할 수 없어 any 로 처리함
    const { order, coupon } = (this.postPredict as any).amounts.refund;
    return this.discountAmt
    - order.additionalDiscountAmt
    - order.freeGiftDiscountAmt
    - coupon.productCouponDiscountAmt
  }
}
